
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ActionContainerCard extends Vue {
  @Prop({ type: String }) readonly title?: string;
  @Prop({ type: Boolean, default: true }) readonly showHeader?: boolean;
  @Prop({ type: Boolean, default: false }) readonly error?: boolean;

  get icon(): { class: string; name: string } | null {
    if (!this.error) return null;

    return { class: "text-red", name: "alert-circle" };
  }

  get hasLinkSlot() {
    return !!this.$slots["link"];
  }

  get hasDescriptionSlot() {
    return !!this.$slots["description"];
  }

  get hasActionsSlot() {
    return !!this.$slots["actions"];
  }

  get hasContentSlot() {
    return !!this.$slots["content"];
  }
}
